// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as LayoutRouteImport } from './routes/_layout'
import { Route as LayoutIndexRouteImport } from './routes/_layout/index'
import { Route as LayoutBeitragsordnungRouteImport } from './routes/_layout/beitragsordnung'
import { Route as LayoutBrandRouteImport } from './routes/_layout/brand'
import { Route as LayoutBusRouteImport } from './routes/_layout/bus'
import { Route as LayoutDatenschutzRouteImport } from './routes/_layout/datenschutz'
import { Route as LayoutFotosRouteImport } from './routes/_layout/fotos'
import { Route as LayoutImpressumRouteImport } from './routes/_layout/impressum'
import { Route as LayoutJugendschutzRouteImport } from './routes/_layout/jugendschutz'
import { Route as LayoutLiveRouteImport } from './routes/_layout/live'
import { Route as LayoutNewsRouteImport } from './routes/_layout/news'
import { Route as LayoutSatzungRouteImport } from './routes/_layout/satzung'
import { Route as LayoutTabelleRouteImport } from './routes/_layout/tabelle'
import { Route as LayoutTeamsRouteImport } from './routes/_layout/teams'
import { Route as LayoutTermineRouteImport } from './routes/_layout/termine'
import { Route as AdminLayoutRouteImport } from './routes/admin/_layout'
import { Route as AdminLoginRouteImport } from './routes/admin/login'
import { Route as AdminOtpLoginRouteImport } from './routes/admin/otp-login'
import { Route as LayoutEUuidRouteImport } from './routes/_layout/e.$uuid'
import { Route as LayoutNewsIndexRouteImport } from './routes/_layout/news.index'
import { Route as LayoutNewsIdRouteImport } from './routes/_layout/news.$id'
import { Route as LayoutTeamsIndexRouteImport } from './routes/_layout/teams.index'
import { Route as LayoutTeamsSlugRouteImport } from './routes/_layout/teams.$slug'
import { Route as LayoutTermineIndexRouteImport } from './routes/_layout/termine.index'
import { Route as LayoutTermineIdRouteImport } from './routes/_layout/termine.$id'
import { Route as AdminLayoutIndexRouteImport } from './routes/admin/_layout/index'
import { Route as AdminLayoutApiKeysRouteImport } from './routes/admin/_layout/api-keys'
import { Route as AdminLayoutBusRouteImport } from './routes/admin/_layout/bus'
import { Route as AdminLayoutEventsRouteImport } from './routes/admin/_layout/events'
import { Route as AdminLayoutLocationsRouteImport } from './routes/admin/_layout/locations'
import { Route as AdminLayoutMembersRouteImport } from './routes/admin/_layout/members'
import { Route as AdminLayoutNewsRouteImport } from './routes/admin/_layout/news'
import { Route as AdminLayoutSamsRouteImport } from './routes/admin/_layout/sams'
import { Route as AdminLayoutSponsorsRouteImport } from './routes/admin/_layout/sponsors'
import { Route as AdminLayoutTeamsRouteImport } from './routes/admin/_layout/teams'
import { Route as AdminLayoutVolunteerEventRouteImport } from './routes/admin/_layout/volunteer-event'
import { Route as AdminLayoutVolunteerEventEventIdMessageRouteImport } from './routes/admin/_layout/volunteer-event_.$eventId.message'

const LayoutRoute = LayoutRouteImport.update({
            id: '/_layout',getParentRoute: () => rootRouteImport
          })
const LayoutIndexRoute = LayoutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutRoute
          })
const LayoutBeitragsordnungRoute = LayoutBeitragsordnungRouteImport.update({
            id: '/beitragsordnung',path: '/beitragsordnung',getParentRoute: () => LayoutRoute
          })
const LayoutBrandRoute = LayoutBrandRouteImport.update({
            id: '/brand',path: '/brand',getParentRoute: () => LayoutRoute
          })
const LayoutBusRoute = LayoutBusRouteImport.update({
            id: '/bus',path: '/bus',getParentRoute: () => LayoutRoute
          })
const LayoutDatenschutzRoute = LayoutDatenschutzRouteImport.update({
            id: '/datenschutz',path: '/datenschutz',getParentRoute: () => LayoutRoute
          })
const LayoutFotosRoute = LayoutFotosRouteImport.update({
            id: '/fotos',path: '/fotos',getParentRoute: () => LayoutRoute
          })
const LayoutImpressumRoute = LayoutImpressumRouteImport.update({
            id: '/impressum',path: '/impressum',getParentRoute: () => LayoutRoute
          })
const LayoutJugendschutzRoute = LayoutJugendschutzRouteImport.update({
            id: '/jugendschutz',path: '/jugendschutz',getParentRoute: () => LayoutRoute
          })
const LayoutLiveRoute = LayoutLiveRouteImport.update({
            id: '/live',path: '/live',getParentRoute: () => LayoutRoute
          })
const LayoutNewsRoute = LayoutNewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => LayoutRoute
          })
const LayoutSatzungRoute = LayoutSatzungRouteImport.update({
            id: '/satzung',path: '/satzung',getParentRoute: () => LayoutRoute
          })
const LayoutTabelleRoute = LayoutTabelleRouteImport.update({
            id: '/tabelle',path: '/tabelle',getParentRoute: () => LayoutRoute
          })
const LayoutTeamsRoute = LayoutTeamsRouteImport.update({
            id: '/teams',path: '/teams',getParentRoute: () => LayoutRoute
          })
const LayoutTermineRoute = LayoutTermineRouteImport.update({
            id: '/termine',path: '/termine',getParentRoute: () => LayoutRoute
          })
const AdminLayoutRoute = AdminLayoutRouteImport.update({
            id: '/admin/_layout',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AdminLoginRoute = AdminLoginRouteImport.update({
            id: '/admin/login',path: '/admin/login',getParentRoute: () => rootRouteImport
          })
const AdminOtpLoginRoute = AdminOtpLoginRouteImport.update({
            id: '/admin/otp-login',path: '/admin/otp-login',getParentRoute: () => rootRouteImport
          })
const LayoutEUuidRoute = LayoutEUuidRouteImport.update({
            id: '/e/$uuid',path: '/e/$uuid',getParentRoute: () => LayoutRoute
          })
const LayoutNewsIndexRoute = LayoutNewsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutNewsRoute
          })
const LayoutNewsIdRoute = LayoutNewsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => LayoutNewsRoute
          })
const LayoutTeamsIndexRoute = LayoutTeamsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutTeamsRoute
          })
const LayoutTeamsSlugRoute = LayoutTeamsSlugRouteImport.update({
            id: '/$slug',path: '/$slug',getParentRoute: () => LayoutTeamsRoute
          })
const LayoutTermineIndexRoute = LayoutTermineIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => LayoutTermineRoute
          })
const LayoutTermineIdRoute = LayoutTermineIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => LayoutTermineRoute
          })
const AdminLayoutIndexRoute = AdminLayoutIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutApiKeysRoute = AdminLayoutApiKeysRouteImport.update({
            id: '/api-keys',path: '/api-keys',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutBusRoute = AdminLayoutBusRouteImport.update({
            id: '/bus',path: '/bus',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutEventsRoute = AdminLayoutEventsRouteImport.update({
            id: '/events',path: '/events',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutLocationsRoute = AdminLayoutLocationsRouteImport.update({
            id: '/locations',path: '/locations',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutMembersRoute = AdminLayoutMembersRouteImport.update({
            id: '/members',path: '/members',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutNewsRoute = AdminLayoutNewsRouteImport.update({
            id: '/news',path: '/news',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutSamsRoute = AdminLayoutSamsRouteImport.update({
            id: '/sams',path: '/sams',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutSponsorsRoute = AdminLayoutSponsorsRouteImport.update({
            id: '/sponsors',path: '/sponsors',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutTeamsRoute = AdminLayoutTeamsRouteImport.update({
            id: '/teams',path: '/teams',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutVolunteerEventRoute = AdminLayoutVolunteerEventRouteImport.update({
            id: '/volunteer-event',path: '/volunteer-event',getParentRoute: () => AdminLayoutRoute
          })
const AdminLayoutVolunteerEventEventIdMessageRoute = AdminLayoutVolunteerEventEventIdMessageRouteImport.update({
            id: '/volunteer-event_/$eventId/message',path: '/volunteer-event/$eventId/message',getParentRoute: () => AdminLayoutRoute
          })





const LayoutNewsRouteChildren = {
  LayoutNewsIdRoute: LayoutNewsIdRoute,LayoutNewsIndexRoute: LayoutNewsIndexRoute
}

const LayoutNewsRouteWithChildren = LayoutNewsRoute._addFileChildren(LayoutNewsRouteChildren)




const LayoutTeamsRouteChildren = {
  LayoutTeamsSlugRoute: LayoutTeamsSlugRoute,LayoutTeamsIndexRoute: LayoutTeamsIndexRoute
}

const LayoutTeamsRouteWithChildren = LayoutTeamsRoute._addFileChildren(LayoutTeamsRouteChildren)




const LayoutTermineRouteChildren = {
  LayoutTermineIdRoute: LayoutTermineIdRoute,LayoutTermineIndexRoute: LayoutTermineIndexRoute
}

const LayoutTermineRouteWithChildren = LayoutTermineRoute._addFileChildren(LayoutTermineRouteChildren)



const LayoutRouteChildren = {
  LayoutBeitragsordnungRoute: LayoutBeitragsordnungRoute,LayoutBrandRoute: LayoutBrandRoute,LayoutBusRoute: LayoutBusRoute,LayoutDatenschutzRoute: LayoutDatenschutzRoute,LayoutFotosRoute: LayoutFotosRoute,LayoutImpressumRoute: LayoutImpressumRoute,LayoutJugendschutzRoute: LayoutJugendschutzRoute,LayoutLiveRoute: LayoutLiveRoute,LayoutNewsRoute: LayoutNewsRouteWithChildren,LayoutSatzungRoute: LayoutSatzungRoute,LayoutTabelleRoute: LayoutTabelleRoute,LayoutTeamsRoute: LayoutTeamsRouteWithChildren,LayoutTermineRoute: LayoutTermineRouteWithChildren,LayoutIndexRoute: LayoutIndexRoute,LayoutEUuidRoute: LayoutEUuidRoute
}

const LayoutRouteWithChildren = LayoutRoute._addFileChildren(LayoutRouteChildren)




const AdminLayoutRouteChildren = {
  AdminLayoutApiKeysRoute: AdminLayoutApiKeysRoute,AdminLayoutBusRoute: AdminLayoutBusRoute,AdminLayoutEventsRoute: AdminLayoutEventsRoute,AdminLayoutLocationsRoute: AdminLayoutLocationsRoute,AdminLayoutMembersRoute: AdminLayoutMembersRoute,AdminLayoutNewsRoute: AdminLayoutNewsRoute,AdminLayoutSamsRoute: AdminLayoutSamsRoute,AdminLayoutSponsorsRoute: AdminLayoutSponsorsRoute,AdminLayoutTeamsRoute: AdminLayoutTeamsRoute,AdminLayoutVolunteerEventRoute: AdminLayoutVolunteerEventRoute,AdminLayoutIndexRoute: AdminLayoutIndexRoute,AdminLayoutVolunteerEventEventIdMessageRoute: AdminLayoutVolunteerEventEventIdMessageRoute
}

const AdminLayoutRouteWithChildren = AdminLayoutRoute._addFileChildren(AdminLayoutRouteChildren)

const rootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,AdminLayoutRoute: AdminLayoutRouteWithChildren,AdminLoginRoute: AdminLoginRoute,AdminOtpLoginRoute: AdminOtpLoginRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)